import React, { useState } from 'react';
import * as Dati from '../../Dati';
import { BinderProduct, Trad } from '../../components';
import { IBinderProduct } from '../../form/Binder'

interface IBinderProductsTabProps{
    ApprovalList: Dati.TDictTipo;
    Editable: boolean;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => any;
    Products: IBinderProduct[];
}  

export const BinderProductsTab: React.FC<IBinderProductsTabProps> = ({ Products, Editable, ApprovalList, OnChange }) => {
    const [activeTab, setActiveTab] = useState(0);

    Products = Products.sort((a: IBinderProduct, b: IBinderProduct) => 
        `${Trad.Trad(a.TipoRamo)} - ${Trad.Trad(a.TipoProdotto)}` < `${Trad.Trad(b.TipoRamo)} - ${Trad.Trad(b.TipoProdotto)}` ? -1 : 1
    );
   
    return (
        <div className="row">
            <div className="col-3">
                <div className="kt-portlet portlet-shadow">
                    <div className="kt-portlet__body">
                        <ul className="nav nav-tabs flex-column nav-tabs-line nav-tabs-line-warning border-bottom-0">
                            {Products.map((product, i) => (
                                <li className="nav-item" key={product.Index}>
                                    <a className={`nav-link${i == activeTab ? ' active' : ''}`} href="#" onClick={(e) => {e.preventDefault(); setActiveTab(i); }}>
                                        {Trad.Trad(product.TipoRamo)} - {Trad.Trad(product.TipoProdotto)}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-9">
                <div className="kt-portlet portlet-shadow">
                    <div className="kt-portlet__body tab-content">
                        <BinderProduct
                            Data={Products[activeTab]}
                            ApprovalList={ApprovalList}
                            Editable={Editable}
                            OnChange={OnChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/Binder/BinderProductsTab.tsx